import React, { useState } from "react";
import { ScatterChart } from "@sia/style-guide";

function PersonalCostsChart({ translate, metrics, showCustomerData }) {
  const [denominator, setDenominator] = useState("total_fte");
  const costDenominators = metrics.metrics.map((item) => {
    const obj = {
      id: item.metric,
      label: translate(`benchmarking.evaluations.overheads.accounts.personnel_costs.${item.metric}`),
      unit: item.metric === "total_fte" ? "CHF" : "%",
      format: item.metric === "total_fte" ? "currency" : "percent",
      decimals: item.metric === "total_fte" ? 0 : 1,
    };
    return obj;
  });
  const active = costDenominators.find((item) => item.id === denominator);
  const title = translate(`benchmarking.evaluations.overheads.accounts.${metrics.costCategory}.${active.id}.title`);
  const personalKyes = [
    { id: "accounts.social-benefits", level: 0 },
    { id: "accounts.pension-plans", level: 1 },
    { id: "accounts.accident-insurance", level: 1 },
    { id: "accounts.daily-sickness-benefits-insurance", level: 1 },
    { id: "accounts.other-personnel-costs", level: 0 },
    { id: "accounts.recruitment-ads", level: 1 },
    { id: "accounts.education-training", level: 0 },
  ];
  const costsMetrics = personalKyes.map((key) => {
    let obj = {};
    obj.id = key.id;
    obj.label = translate(`benchmarking.evaluations.overheads.${key.id}`);
    obj.level = key.level;
    const values = metrics.metrics.reduce((acc, metric) => {
      const propertyName = metric.metric;
      acc[propertyName] = {};
      const account = metric.accounts.find((e) => e.accountKey === key.id);
      if (account) {
        acc[propertyName]["customerValue"] = account.companyValue;
        const mean = account.benchmark.mean;
        const stddev = account.benchmark.stddev;
        acc[propertyName]["mean"] = mean;
        if (stddev > mean / 2) {
          acc[propertyName]["sd"] = mean / 2;
        } else {
          acc[propertyName]["sd"] = stddev;
        }
      }
      return acc;
    }, {});
    obj.values = values;
    return obj;
  });

  return (
    <div>
      <ScatterChart
        translate={translate}
        title={title}
        subtitle={translate(`benchmarking.evaluations.overheads.accounts.${metrics.costCategory}.subtitle`)}
        metrics={costsMetrics}
        denominators={costDenominators}
        denominatorLabel={translate("benchmarking.evaluations.overheads.accounts.denominator")}
        unitLabel={translate("benchmarking.evaluations.overheads.accounts.unit")}
        selectedDenominator={denominator}
        onDenominatorChange={setDenominator}
        showCustomerData={showCustomerData}
      />
    </div>
  );
}

export default PersonalCostsChart;
